export default __webpack_public_path__ + "static/media/opticaleo.e8b1deae.jpeg";